export const WORKSHOP_SIZES = ['solo', 'small', 'medium', 'large'] as const;
export const DEMO_INTERESTS = [
  'work-orders',
  'calendar',
  'inventory',
  'invoicing',
  'customer-portal',
  'whatsapp',
  'mobile',
] as const;

export type WorkshopSize = (typeof WORKSHOP_SIZES)[number];
export type DemoInterest = (typeof DEMO_INTERESTS)[number];

export const workshopSizeOptions = WORKSHOP_SIZES.map((value) => ({
  value,
  labelKey: `workshopSizeOptions.${value}`,
}));

export const interestOptions = DEMO_INTERESTS.map((value) => ({
  value,
  labelKey: `interestOptions.${value}`,
}));

export interface DemoRequestPayload {
  contactName: string;
  company: string;
  email: string;
  phone?: string;
  workshopSize: WorkshopSize;
  interests: DemoInterest[];
  locale: 'fi' | 'en' | 'sv';
  consent: true;
  source?: {
    referrer?: string;
    utmSource?: string;
    utmMedium?: string;
    utmCampaign?: string;
  };
}

export function readAllowedSource(search: string, referrer: string): DemoRequestPayload['source'] {
  const params = new URLSearchParams(search);
  const source: NonNullable<DemoRequestPayload['source']> = {};
  const referrerValue = referrer.trim();
  if (referrerValue) source.referrer = referrerValue.slice(0, 500);
  const utmSource = params.get('utm_source');
  const utmMedium = params.get('utm_medium');
  const utmCampaign = params.get('utm_campaign');
  if (utmSource) source.utmSource = utmSource.slice(0, 100);
  if (utmMedium) source.utmMedium = utmMedium.slice(0, 100);
  if (utmCampaign) source.utmCampaign = utmCampaign.slice(0, 100);
  return Object.keys(source).length > 0 ? source : undefined;
}
